export function checkIfUserIsOnMobile(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  );
}
